import React, {createContext, useState, useContext, useEffect} from "react";
import {ReactNode} from "react";
import {getUserRoleFromToken} from "../utils/auth";

interface AuthContextType {
    isLoggedIn: boolean;
    userRole: string;
    token: string | null;
    login: () => void;
    logout: () => void;
    saveToken: (token: string) => void;
    authLoading: boolean;
}

const AuthContext = createContext<AuthContextType>({
    isLoggedIn: false,
    userRole: "",
    token: null,
    login: () => {},
    logout: () => {},
    saveToken: () => {},
    authLoading: true,
});


export const AuthProvider = ({children}: { children: ReactNode }) => {
    const [token, setToken] = useState<string | null>(null);
    const [userRole, setUserRole] = useState<string>("");
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [authLoading, setAuthLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem("token");
        if (storedToken) {
            setToken(storedToken);
            setIsLoggedIn(true);
            const role = getUserRoleFromToken(storedToken);
            setUserRole(role);
        }
        setAuthLoading(false);
    }, []);

    const login = () => {
        setIsLoggedIn(true);
    };

    const logout = () => {
        setIsLoggedIn(false);
        setUserRole("");
        setToken(null);
        localStorage.removeItem("token");
    };

    const saveToken = (newToken: string) => {
        localStorage.setItem("token", newToken);
        const role = getUserRoleFromToken(newToken);
        setUserRole(role);
    };

    return (
        <AuthContext.Provider value={{isLoggedIn, userRole, token, login, logout, saveToken, authLoading}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);